export { default } from './socials.view';
